import React from 'react';
import { Card, Col } from 'react-bootstrap';
import BtnLink from '../CustomLink/BtnLink';
import './Service.css'

const Service = (props) => {
    const {id,name,body,price,btnText,img} = props.service;
    return (
        <Col>
        <Card className='h-100 img-height shadow'>
         <div className='d-flex justify-content-center m-1'> <Card.Img variant="top" src={img} /></div>
          <Card.Body>
            <Card.Title>
                 <div className='d-flex justify-content-between'>
                      <span>{name}</span>
                       <span className='text-danger ms-3'>{`${price} TK Only`}</span>
                 </div>
            </Card.Title>
            <Card.Text>
             {body}
            </Card.Text>
          </Card.Body>
          <div  className='d-flex justify-content-center my-3'>
          <BtnLink className="btn-my" to='/checkout'>{btnText}</BtnLink>
          </div>
        </Card>
      </Col>
    );
};

export default Service;